import React, { Component } from 'react';
import AdminLayout from './layout';

class dashboardNew  extends Component {

    constructor(props) {
        super(props);
        this.state = {
          school_data: []
        };
    }

    render() {

        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="row  mt-3">

            <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Reports</h4>
             
                
                <div class="flexrowitems">

                          <div class="mockup_report_1">
                               
                          </div>

                </div>

                </div>
              </div>

            </div>                           

            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default dashboardNew;


// WEBPACK FOOTER //
// ./src/components/bewise/dashboardNew.jsx